module.exports = __webpack_public_path__ + "static/scale-model-of-mission-concepción-in-san-antonio-texas-b487f4cd87c11373e8cc4cd396f9b37d.png";